/** @type {OsNamesFindResponse} */
export const result = {
  header: {
    uri: 'https://api.os.uk/search/names/v1/find?query=NW1%206XE&fq=local_type%3Apostcode%20local_type%3Ahamlet%20local_type%3Avillage%20local_type%3Atown%20local_type%3Acity%20local_type%3Aother_settlement&maxresults=8',
    query: 'NW1 6XE',
    format: 'JSON',
    maxresults: 8,
    offset: 0,
    totalresults: 2016,
    filter:
      'fq=local_type:postcode local_type:hamlet local_type:village local_type:town local_type:city local_type:other_settlement'
  },
  results: [
    {
      GAZETTEER_ENTRY: {
        ID: 'NW16XE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW16XE',
        NAME1: 'NW1 6XE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 527850,
        GEOMETRY_Y: 182134,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'City of Westminster',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074559881',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'City of Westminster',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011164',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW26XE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW26XE',
        NAME1: 'NW2 6XE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 523065,
        GEOMETRY_Y: 185795,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'London',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074813508',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'Brent',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011447',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW36XE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW36XE',
        NAME1: 'NW3 6XE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 526197,
        GEOMETRY_Y: 185535,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'Hampstead',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074541613',
        DISTRICT_BOROUGH: 'Camden',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011244',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW10XE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW10XE',
        NAME1: 'NW1 0XE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 529608,
        GEOMETRY_Y: 183996,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'Camden Town',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074557754',
        DISTRICT_BOROUGH: 'Camden',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011244',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW16AE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW16AE',
        NAME1: 'NW1 6AE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 527873,
        GEOMETRY_Y: 182010,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'City of Westminster',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074559881',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'City of Westminster',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011164',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW16DE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW16DE',
        NAME1: 'NW1 6DE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 527681,
        GEOMETRY_Y: 182107,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'City of Westminster',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074559881',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'City of Westminster',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011164',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW16EX',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW16EX',
        NAME1: 'NW1 6EX',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 527534,
        GEOMETRY_Y: 182220,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'City of Westminster',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074559881',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'City of Westminster',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011164',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    },
    {
      GAZETTEER_ENTRY: {
        ID: 'NW16HE',
        NAMES_URI: 'http://data.ordnancesurvey.co.uk/id/postcodeunit/NW16HE',
        NAME1: 'NW1 6HE',
        TYPE: 'other',
        LOCAL_TYPE: 'Postcode',
        GEOMETRY_X: 527621,
        GEOMETRY_Y: 182113,
        MOST_DETAIL_VIEW_RES: 3500,
        LEAST_DETAIL_VIEW_RES: 18000,
        POPULATED_PLACE: 'City of Westminster',
        POPULATED_PLACE_URI:
          'http://data.ordnancesurvey.co.uk/id/4000000074559881',
        POPULATED_PLACE_TYPE:
          'http://www.ordnancesurvey.co.uk/xml/codelists/localtype.xml#city',
        DISTRICT_BOROUGH: 'City of Westminster',
        DISTRICT_BOROUGH_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000011164',
        DISTRICT_BOROUGH_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/LondonBorough',
        COUNTY_UNITARY: 'Greater London',
        COUNTY_UNITARY_URI:
          'http://data.ordnancesurvey.co.uk/id/7000000000041441',
        COUNTY_UNITARY_TYPE:
          'http://data.ordnancesurvey.co.uk/ontology/admingeo/GreaterLondonAuthority',
        REGION: 'London',
        REGION_URI: 'http://data.ordnancesurvey.co.uk/id/7000000000041428',
        COUNTRY: 'England',
        COUNTRY_URI: 'http://data.ordnancesurvey.co.uk/id/country/england'
      }
    }
  ]
}

/**
 * @import { OsNamesFindResponse } from '~/src/server/plugins/map/types.js'
 */
